import { Box } from '@mui/material'
import AiAskBarAttachmentsSection from './AiAskBarAttachmentsSection'
import AiAskBarHomeMainGrid from './AiAskBarHomeMainGrid'
import AiAskBarLandingVoiceRow from './AiAskBarLandingVoiceRow'
import styles from './index.module.scss'

export default function AiAskBarHomeInputPanel(props) {
  const { vm, actions, replyPreview, onDismissReplyPreview, buildMode, sendDisabled, onVoiceToggle, voiceActive, model, onModelChange, landing = false, contentWidth, plainLanding = false } = props
  const showSelects = contentWidth !== 'page' && !plainLanding
  // Live voice replaces the whole panel body, so it also drops the attachment
  // tray — there is no composer left for an attachment to belong to. This is
  // not gated on `landing`: starting voice from the home screen opens a thread,
  // so gating it there would collapse the composer only on the screen you just
  // navigated away from.
  const voiceCollapsed = voiceActive
  const className = [styles.inputPanel, buildMode ? styles.inputPanelBuild : '', landing ? styles.inputPanelLanding : '', voiceCollapsed ? styles.inputPanelVoice : '']
    .filter(Boolean)
    .join(' ')

  if (voiceCollapsed) {
    return (
      <Box className={className}>
        <AiAskBarLandingVoiceRow vm={vm} actions={actions} onVoiceToggle={onVoiceToggle} />
      </Box>
    )
  }

  return (
    <Box className={className}>
      <AiAskBarAttachmentsSection
        replyPreview={replyPreview}
        replySnippet={vm.replySnippet}
        onDismissReplyPreview={onDismissReplyPreview}
        refinementText={vm.refinementText}
        onDismissRefinement={vm.clearRefinement}
        attachments={vm.attachments}
        imageAttachments={vm.imageAttachments}
        docAttachments={vm.docAttachments}
        onRemoveAttachment={actions.handleRemoveAttachment}
        openAttachmentGalleryAtId={vm.openAttachmentGalleryAtId}
      />
      <AiAskBarHomeMainGrid vm={vm} actions={actions} sendDisabled={sendDisabled} onVoiceToggle={onVoiceToggle} voiceActive={voiceActive} model={model} onModelChange={onModelChange} landing={landing} showSelects={showSelects} />
    </Box>
  )
}
